import type { PartnerRevenueApiData, PartnerRevenueApiResponses } from '@navio/nsdk';
import { apiUrl, dataEndpoint } from '../defineResource';

export const getRevenueUrls = {
  getPartnerRevenue: dataEndpoint<PartnerRevenueApiData, PartnerRevenueApiResponses>({
    getUrl: ({ serviceDepartmentId, ...query }) => apiUrl(`service-departments/${serviceDepartmentId}/revenue/`, query)
  })
};
